export default "<app-company-form (onsubmit)=\"save($event)\"></app-company-form>";